import React from 'react';
import ModernBlogDetails from './ModernBlogDetails';

// Main BlogDetails component that uses the modern version
const BlogSingle = (props) => {
  return <ModernBlogDetails {...props} />;
};

export default BlogSingle;
